module.exports = __webpack_public_path__ + "static/media/bg_3.ad7d5ca9.jpg";